/**
 * Which design language the document is rendering in, readable outside React.
 *
 * `useDesign()` is the right answer inside a component. This exists for the few
 * pure helpers — date formatters, mostly — that have to differ between the two
 * looks but have no hook to call. It reads the same attribute the CSS layer
 * keys on, so it can never disagree with what is on screen.
 */
export function isStudioDesign() {
  try {
    return document.documentElement.getAttribute('data-design') === 'studio';
  } catch {
    return false;
  }
}

export default isStudioDesign;
